import type { Spaces } from '@cds/content-spaces'

type EASpace = Exclude<Spaces['attributes']['name'], 'crepo-runscope'>

interface AuthSettingsModel {
  allLocales: 'DPS Web BE - Locale - All Locales'
  allSpaces: 'DPS Web BE - Space - All Spaces'
  defaultSpace: EASpace
  mappings: {
    locales: Record<string, string>
    roles: Record<string, string>
    spaces: Record<EASpace, string>
  }
}

/* eslint-disable camelcase */
export const userAuthorizationSettings = {
  allLocales: 'DPS Web BE - Locale - All Locales',
  allSpaces: 'DPS Web BE - Space - All Spaces',
  defaultSpace: 'redbull_com',
  mappings: {
    roles: {
      admin: 'DPS Web BE - EA - Admin',
      'all-localizations': 'DPS Web BE - Locale - All Locales',
      'all-spaces': 'DPS Web BE - Space - All Spaces',
      'content-editor': 'DPS Web BE - EA - Content Editor',
      'content-hub-manager': 'DPS Web BE - EA - Content Hub Creator',
      'content-manager': 'DPS Web BE - EA - Content Manager',
      curator: 'DPS Web BE - RBMH Dotcom Curator',
      'embargo-date-manager': 'DPS Web BE - EA - Embargo Date Manager',
      'featuring-app-access': 'DPS Web BE - FA - Access',
      'onsite-promotion-editor': 'DPS Web BE - EA - Onsite Promotion Editor',
      publisher: 'DPS Web BE - EA - Publisher',
      'rbtv-content-creator': 'DPS Web BE - EA - RBTV Content Creator',
      'taxonomy-manager': 'DPS Web BE - EA - Taxonomy Manager',
      'technical-admin-user': 'DPS Web BE - Access Level - RBWEB Technical Admin User',
      technician: 'DPS Web BE - EA - Technician',
      translator: 'DPS Web BE - EA - Translator',
      'xc-editor': 'DPS Web BE - XC - Access',
    },
    spaces: {
      alinghi: 'DPS Web BE - Space - Alinghi',
      batalla: 'DPS Web BE - Space - Batalla',
      'brand-building-events': 'DPS Web BE - Space - Brand Building Events',
      cartoons: 'DPS Web BE - Space - Cartoons',
      erc: 'DPS Web BE - Space - ERC',
      global: 'DPS Web BE - EA - Taxonomy Manager',
      illume: 'DPS Web BE - Space - Illume',
      'media-partnerships': 'DPS Web BE - Space - Media Partnerships',
      organics: 'DPS Web BE - Space - Organics',
      'organics-mixed-consumption': 'DPS Web BE - Space - Organics',
      'pro-cycling': 'DPS Web BE - Space - Pro Cycling',
      'racing-bulls': 'DPS Web BE - Space - VCARB',
      'rb-juniorteam': 'DPS Web BE - Space - Junior Team',
      'rb-rookies': 'DPS Web BE - Space - Rookies Cup',
      rbtv: 'DPS Web BE - Space - RBTV',
      rbtv_temporary: 'DPS Web BE - Space - RBTV temporary',
      redbull_com: 'DPS Web BE - Space - redbullcom',
      'redbull-advancedtechnologies': 'DPS Web BE - Space - Advanced Technologies',
      'redbull-f1academy': 'DPS Web BE - Space - RBR F1 Academy',
      'redbull-powertrains': 'DPS Web BE - Space - Powertrains',
      'redbull-racing': 'DPS Web BE - Space - Red Bull Racing',
      'redbull-simracing': 'DPS Web BE - Space - RBR Sim Racing',
      redbulletin: 'DPS Web BE - Space - The Red Bulletin',
      redbullmusic: 'DPS Web BE - Space - Music',
      speedweek: 'DPS Web BE - Space - Speedweek',
      wingfinder: 'DPS Web BE - Space - Wingfinder',
      wrc: 'DPS Web BE - Space - WRC',
      wrcpromoter: 'DPS Web BE - Space - WRC Promoter',
      xalps: 'DPS Web BE - Space - XAlps',
    },
    locales: {
      'ar-BH': 'DPS Web BE - Locale - ar-BH',
      'ar-DZ': 'DPS Web BE - Locale - ar-DZ',
      'ar-EG': 'DPS Web BE - Locale - ar-EG',
      'ar-JO': 'DPS Web BE - Locale - ar-JO',
      'ar-KW': 'DPS Web BE - Locale - ar-KW',
      'ar-LB': 'DPS Web BE - Locale - ar-LB',
      'ar-MA': 'DPS Web BE - Locale - ar-MA',
      'ar-MEA': 'DPS Web BE - Locale - ar-MEA',
      'ar-OM': 'DPS Web BE - Locale - ar-OM',
      'ar-QA': 'DPS Web BE - Locale - ar-QA',
      'ar-SA': 'DPS Web BE - Locale - ar-SA',
      'ar-TN': 'DPS Web BE - Locale - ar-TN',
      'az-AZ': 'DPS Web BE - Locale - az-AZ',
      'bg-BG': 'DPS Web BE - Locale - bg-BG',
      'bs-BA': 'DPS Web BE - Locale - bs-BA',
      'cs-CZ': 'DPS Web BE - Locale - cs-CZ',
      'da-DK': 'DPS Web BE - Locale - da-DK',
      de: 'DPS Web BE - Locale - de-INT',
      'de-AT': 'DPS Web BE - Locale - de-AT',
      'de-CH': 'DPS Web BE - Locale - de-CH',
      'de-DE': 'DPS Web BE - Locale - de-DE',
      'el-CY': 'DPS Web BE - Locale - el-CY',
      'el-GR': 'DPS Web BE - Locale - el-GR',
      en: 'DPS Web BE - Locale - en-INT',
      'en-AU': 'DPS Web BE - Locale - en-AU',
      'en-CA': 'DPS Web BE - Locale - en-CA',
      'en-CAR': 'DPS Web BE - Locale - en-CAR',
      'en-EG': 'DPS Web BE - Locale - en-EG',
      'en-EU': 'DPS Web BE - Locale - en-EU',
      'en-GB': 'DPS Web BE - Locale - en-GB',
      'en-HK': 'DPS Web BE - Locale - en-HK',
      'en-IE': 'DPS Web BE - Locale - en-IE',
      'en-IN': 'DPS Web BE - Locale - en-IN',
      'en-JM': 'DPS Web BE - Locale - en-JM',
      'en-KE': 'DPS Web BE - Locale - en-KE',
      'en-KW': 'DPS Web BE - Locale - en-KW',
      'en-LK': 'DPS Web BE - Locale - en-LK',
      'en-MEA': 'DPS Web BE - Locale - en-MEA',
      'en-MK': 'DPS Web BE - Locale - en-MK',
      'en-MT': 'DPS Web BE - Locale - en-MT',
      'en-MV': 'DPS Web BE - Locale - en-MV',
      'en-MY': 'DPS Web BE - Locale - en-MY',
      'en-NA': 'DPS Web BE - Locale - en-NA',
      'en-NG': 'DPS Web BE - Locale - en-NG',
      'en-NZ': 'DPS Web BE - Locale - en-NZ',
      'en-OM': 'DPS Web BE - Locale - en-OM',
      'en-PH': 'DPS Web BE - Locale - en-PH',
      'en-PK': 'DPS Web BE - Locale - en-PK',
      'en-SE': 'DPS Web BE - Locale - en-SE',
      'en-SG': 'DPS Web BE - Locale - en-SG',
      'en-US': 'DPS Web BE - Locale - en-US',
      'en-ZA': 'DPS Web BE - Locale - en-ZA',
      es: 'DPS Web BE - Locale - es-INT',
      'es-AR': 'DPS Web BE - Locale - es-AR',
      'es-BO': 'DPS Web BE - Locale - es-BO',
      'es-CAR': 'DPS Web BE - Locale - es-CAR',
      'es-CL': 'DPS Web BE - Locale - es-CL',
      'es-CO': 'DPS Web BE - Locale - es-CO',
      'es-CR': 'DPS Web BE - Locale - es-CR',
      'es-DO': 'DPS Web BE - Locale - es-DO',
      'es-EC': 'DPS Web BE - Locale - es-EC',
      'es-ES': 'DPS Web BE - Locale - es-ES',
      'es-LAT': 'DPS Web BE - Locale - es-LAT',
      'es-MX': 'DPS Web BE - Locale - es-MX',
      'es-PA': 'DPS Web BE - Locale - es-PA',
      'es-PE': 'DPS Web BE - Locale - es-PE',
      'et-EE': 'DPS Web BE - Locale - et-EE',
      'fi-FI': 'DPS Web BE - Locale - fi-FI',
      fr: 'DPS Web BE - Locale - fr-INT',
      'fr-BE': 'DPS Web BE - Locale - fr-BE',
      'fr-CA': 'DPS Web BE - Locale - fr-CA',
      'fr-CH': 'DPS Web BE - Locale - fr-CH',
      'fr-DZ': 'DPS Web BE - Locale - fr-DZ',
      'fr-FR': 'DPS Web BE - Locale - fr-FR',
      'fr-MU': 'DPS Web BE - Locale - fr-MU',
      'fr-SN': 'DPS Web BE - Locale - fr-SN',
      'he-IL': 'DPS Web BE - Locale - he-IL',
      'hi-IN': 'DPS Web BE - Locale - hi-IN',
      'hr-HR': 'DPS Web BE - Locale - hr-HR',
      'hu-HU': 'DPS Web BE - Locale - hu-HU',
      'id-ID': 'DPS Web BE - Locale - id-ID',
      'is-IS': 'DPS Web BE - Locale - is-IS',
      'it-IT': 'DPS Web BE - Locale - it-IT',
      'ja-JP': 'DPS Web BE - Locale - ja-JP',
      'ru-KZ': 'DPS Web BE - Locale - ru-KZ',
      'ka-GE': 'DPS Web BE - Locale - ka-GE',
      'ko-KR': 'DPS Web BE - Locale - ko-KR',
      'lt-LT': 'DPS Web BE - Locale - lt-LT',
      'lv-LV': 'DPS Web BE - Locale - lv-LV',
      'mk-MK': 'DPS Web BE - Locale - mk-MK',
      'nl-BE': 'DPS Web BE - Locale - nl-BE',
      'nl-NL': 'DPS Web BE - Locale - nl-NL',
      'no-NO': 'DPS Web BE - Locale - no-NO',
      'pl-PL': 'DPS Web BE - Locale - pl-PL',
      'pt-AO': 'DPS Web BE - Locale - pt-AO',
      'pt-BR': 'DPS Web BE - Locale - pt-BR',
      'pt-PT': 'DPS Web BE - Locale - pt-PT',
      'ro-RO': 'DPS Web BE - Locale - ro-RO',
      'ru-BY': 'DPS Web BE - Locale - ru-BY',
      'ru-RU': 'DPS Web BE - Locale - ru-RU',
      'ru-UZ': 'DPS Web BE - Locale - ru-UZ',
      'sk-SK': 'DPS Web BE - Locale - sk-SK',
      'sl-SI': 'DPS Web BE - Locale - sl-SI',
      'sq-AL': 'DPS Web BE - Locale - sq-AL',
      'sq-KV': 'DPS Web BE - Locale - sq-KV',
      'sr-RS': 'DPS Web BE - Locale - sr-RS',
      'sr-ME': 'DPS Web BE - Locale - sr-ME',
      'sv-SE': 'DPS Web BE - Locale - sv-SE',
      'th-TH': 'DPS Web BE - Locale - th-TH',
      'tr-TR': 'DPS Web BE - Locale - tr-TR',
      'uk-UA': 'DPS Web BE - Locale - uk-UA',
      'zh-CN': 'DPS Web BE - Locale - zh-CN',
      'zh-HK': 'DPS Web BE - Locale - zh-HK',
      'zh-TW': 'DPS Web BE - Locale - zh-TW',
    },
  },
} as const satisfies AuthSettingsModel
